import { render, staticRenderFns } from "./toza_pribil.vue?vue&type=template&id=22cff68c&scoped=true&"
import script from "./toza_pribil.vue?vue&type=script&lang=js&"
export * from "./toza_pribil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cff68c",
  null
  
)

export default component.exports